import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {DomService} from 'app/core/services/dom.service';
import {CookieService} from 'ngx-cookie-service';
import {Subscription} from 'rxjs';

const SIDEBAR_COOKIE_FIELD = 'sidebar_full';
const SIDEBAR_FULL_VALUE = '1';

@Component({
    selector: 'navigation-toggle',
    templateUrl: './navigation-toggle.component.html',
    styleUrls: ['./navigation-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationToggleComponent implements OnInit, OnDestroy {
    @Input() navExpanded: boolean;
    @Output() navExpandedChange = new EventEmitter<boolean>();

    private shouldBeSaved: boolean;
    private mediaQuerySubscription: Subscription;
    private changeTimer;

    constructor(
        private cookieService: CookieService,
        private domService: DomService
    ) {}

    ngOnInit() {
        this.mediaQuerySubscription = this.domService.media('(min-width: 767px)').subscribe(mql => {
            this.shouldBeSaved = mql.matches;
            this.navExpanded = this.shouldBeSaved ? this.getSavedValue() : false;
            this.emitChange();
        });
    }

    ngOnDestroy() {
        this.mediaQuerySubscription.unsubscribe();
    }

    onClick() {
        this.toggleState();
    }

    getSavedValue(): boolean {
        return this.cookieService.get(SIDEBAR_COOKIE_FIELD) === SIDEBAR_FULL_VALUE;
    }

    toggleState(value = !this.navExpanded) {
        this.navExpanded = value;
        if (this.shouldBeSaved) {
            this.cookieService.set(SIDEBAR_COOKIE_FIELD, Number(this.navExpanded).toString());
        }
        this.emitChange();
    }

    emitChange() {
        this.navExpandedChange.emit(this.navExpanded);
        clearTimeout(this.changeTimer);
        this.changeTimer = setTimeout(() => window.dispatchEvent(new Event('resize')), 300);
    }
}
